<template>

    <!-- 事件等级统计 -->
    <div>
        <el-col :span="16">
            <div ref="ticketLevelChart" :style="astyle">
            </div>
        </el-col>
        <el-col :span="8">
            <p class="bold">数据中心等级事件对比</p>
            <p>一级事件总数：<span class="orange-font bold">{{level1Total}}</span></p>
            <p>二级事件总数：<span class="orange-font bold">{{level2Total}}</span></p>
            <p>三级事件总数：<span class="orange-font bold">{{level3Total}}</span></p>
        </el-col>
    </div>

</template>

<script>
    import {formatDate, parseDate} from "element-ui/src/utils/date-util";
    import TicketServer from "@/api/ticket";
    import echarts from "echarts";

    let that;

    export default {
        name: "ticketLevelNumStatistics",

        props: {
            astyle: {
                type: String,
            },
            dcnumids: {
                type: Array,
            },
            dcnumMap: null,
            searchDate: {
                type: String,
                default() {
                    return formatDate(new Date(), 'yyyy-MM');
                }
            },
        },

        data() {
            return {
                level1Total: 0,
                level2Total: 0,
                level3Total: 0,
            }
        },

        methods: {
            query() {
                let searchStartDate = formatDate(this.getFirstDayOfMonth(this.searchDate), 'yyyy-MM-dd');
                let searchEndDate = formatDate(this.getLastDayOfMonth(this.searchDate), 'yyyy-MM-dd');
                let params = {
                    'dcnums': this.dcnumids,
                    'startdate': searchStartDate,
                    'enddate': searchEndDate,
                    'status': ['DRAFT', 'WACCEPT', 'WHANDLE', 'WAPPR', 'SUSPEND', 'CLOSE'],
                    'class': 'INCIDENT',
                }
                TicketServer.ticket.queryTicketLevelInfo(params).then(res => {
                    this.level1Total = res.level1Total;
                    this.level2Total = res.level2Total;
                    this.level3Total = res.level3Total;
                    this.renderLevelNumChart(this.level1Total, this.level2Total, this.level3Total);
                });
            },

            getFirstDayOfMonth(date) {
                let current = date == null ? new Date() : date + '-01';
                current = parseDate(current, 'yyyy-MM-dd');
                return new Date(current.getFullYear(), current.getMonth(), 1, 0, 0, 0, 0);
            },

            getLastDayOfMonth(date) {
                let current = date == null ? new Date() : date + '-01';
                current = parseDate(current, 'yyyy-MM-dd');
                let firstDateInNextMonth = new Date(current.getFullYear(), current.getMonth() + 1, 1, 0, 0, 0, 0);
                return new Date(firstDateInNextMonth.getTime() - 1);
            },

            renderLevelNumChart(level1Total, level2Total, level3Total) {
                let myChart = echarts.init(this.$refs.ticketLevelChart);
                let option = {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b}: {c} ({d}%)'
                    },
                    legend: {
                        orient: 'vertical',
                        left: 10,
                        data: ['一级事件', '二级事件', '三级事件']
                    },
                    series: [
                        {
                            name: '数据中心等级事件对比',
                            type: 'pie',
                            radius: ['40%', '50%'],
                            avoidLabelOverlap: false,
                            label: {
                                show: true,
                                position: 'left'
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: '20',
                                    fontWeight: 'bold'
                                }
                            },
                            labelLine: {
                                show: true
                            },
                            data: [
                                {value: level1Total, name: '一级事件'},
                                {value: level2Total, name: '二级事件'},
                                {value: level3Total, name: '三级事件'}
                            ]

                        }
                    ]
                };
                myChart.setOption(option);
            },
        },

        watch: {
            dcnumids: {
                immediate: true,
                handler: function (newVal, oldVal) {
                    if (newVal != null && newVal.length > 0) {
                        this.query();
                    }
                }
            },

            searchDate: {
                handler: function (newVal, oldVal) {
                    if (newVal != null && newVal != '') {
                        this.query();
                    }
                }
            },
        },

        created() {
            that = this;
        },
    }
</script>

<style scoped>

</style>